<script>
    import FormInputMixin from './Input.vue';
    export default {
        mixins: [FormInputMixin],
        data() {
            return {
                inputType: 'text'
            }
        },
        mounted() {
            this.update(this.initialValue);
        }
    }
</script>